import React, { useState, useEffect } from "react";
import Button from "@material-ui/core/Button";
import Avatar from "@material-ui/core/Avatar";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Box from "@material-ui/core/Box";
import Link from "@material-ui/core/Link";
import Grid from "@material-ui/core/Grid";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import ResetPassword from "../Modals/resetPassword";
import ResponseModal from "../Modals/responseModal";
import MyBackdrop from "../Modals/backDrop";
import { login, resetPassword } from "../../Sevices/api-requests";
import { useNavigate } from "react-router-dom";
import { Navigate } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100vh",
  },
  image: {
    backgroundImage: "url(https://i.imgur.com/eXokdlE.jpg)",
    backgroundRepeat: "no-repeat",
    backgroundColor:
      theme.palette.type === "light"
        ? theme.palette.grey[50]
        : theme.palette.grey[900],
    backgroundSize: "cover",
    backgroundPosition: "top center",
  },
  paper: {
    margin: theme.spacing(8, 4),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {"Copyright © "}
      <Link color="inherit" href="https://www.linkedin.com/in/DrFemzy">
        Adesokan Emmanuel
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

function SignIn({ isLoggedIn, setToken }) {
  const classes = useStyles();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [open, setOpen] = useState(false);
  const [responseOpen, setResponseOpen] = useState(false);
  const [modalEmail, setModalEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = async (mail) => {
    setLoading(true);
    resetPassword(mail)
      .then((response) => {
        setOpen(false);
        setResponseOpen(true);
        setSuccess(true);
        setLoading(false);
      })
      .catch((err) => {
        setOpen(false);
        setResponseOpen(true);
        setLoading(false);
        setSuccess(false);
      });
  };

  const saveUserAndToken = (user) => {
    if (user) {
      localStorage.setItem("user", JSON.stringify(user));
      localStorage.setItem("user_token", user.token);
      return;
    }
  };
  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      const user = await login(email, password);
      const token = user.data.data;
      saveUserAndToken(user.data.data);
      setEmail("");
      setPassword("");
      navigate("/dashboard");
      setToken();
    } catch (error) {
      console.log("err", error);
      setError("Incorrect username or pass");
    }
  };

  return isLoggedIn ? (
    <Navigate replace to="/dashboard" />
  ) : (
    <Grid container component="main" className={classes.root}>
      <CssBaseline />
      <Grid item xs={false} sm={4} md={7} className={classes.image} />
      <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
        <div className={classes.paper}>
          <Avatar className={classes.avatar}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Sign in
          </Typography>
          <form className={classes.form} onSubmit={handleSubmit} noValidate>
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              value={email}
              id="email"
              label="Email Address"
              name="email"
              autoComplete="email"
              autoFocus
              onChange={(event) => {
                const { value } = event.target;
                setEmail(value);
                setError("");
              }}
            />
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              value={password}
              name="password"
              label="Password"
              type="password"
              id="password"
              autoComplete="current-password"
              onChange={(event) => {
                const { value } = event.target;
                setPassword(value);
                setError("");
              }}
            />
            <Grid>
              {error ? (
                <Box color="red" xs={12} sm={6}>
                  {error}!!
                </Box>
              ) : null}
            </Grid>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              className={classes.submit}
            >
              Sign In
            </Button>
            <Grid container>
              <Grid item xs>
                <Link href="#" onClick={handleClickOpen} variant="body2">
                  Forgot password?
                </Link>
              </Grid>
              <Grid item>
                <Link href="/register" variant="body2">
                  Register.
                </Link>
              </Grid>
              <Grid item>
                <ResetPassword
                  setModalEmail={setModalEmail}
                  modalEmail={modalEmail}
                  open={open}
                  handleClose={handleClose}
                />
              </Grid>
              <Grid item>
                <ResponseModal
                  responseOpen={responseOpen}
                  loading={loading}
                  success={success}
                  setResponseOpen={setResponseOpen}
                />
              </Grid>
            </Grid>
            <Box mt={5}>
              <Copyright />
            </Box>
          </form>
        </div>
      </Grid>
    </Grid>
  );
}

export default SignIn;
